import { useEffect, useState } from "react";

export function useViewScopedDebounce<T>(
  value: T,
  delay: number,
  viewKey: string | null,
): T {
  const [state, setState] = useState({ value, viewKey });
  const viewChanged = state.viewKey !== viewKey;

  useEffect(() => {
    if (viewChanged) {
      setState({ value, viewKey });
      return;
    }

    const timeout = setTimeout(() => setState({ value, viewKey }), delay);
    return () => clearTimeout(timeout);
  }, [delay, value, viewChanged, viewKey]);

  return viewChanged ? value : state.value;
}
